import moment from 'moment';
export default {
  data() {
    return {
      visible: false,
      dateFrame: [],
      itemObj: {
        timeFrame: '',
        timeName: ''
      },
      num: '',
      selectPriceDate: '',
      offsetDays: 86400000 * 365
    };
  },
  methods: {
    init(timeVal, num) {
      console.log(timeVal, 222);
      this.itemObj.timeFrame = timeVal.timeFrame;
      this.dateFrame = timeVal.dateFrame || [];
      this.itemObj.timeName = timeVal.timeFrame == 'WEEK' ? this.$t('本周') : timeVal.timeFrame == 'MONTH' ? this.$t('本月') : timeVal.timeFrame == 'MARCH' ? this.$t('近三月') : timeVal.timeFrame == 'YEAR' ? this.$t('本年') : '';
      this.num = num;
      this.visible = true;
    },
    handleSure() {
      this.itemObj.dateFrame = this.dateFrame;
      console.log(this.itemObj, 22221);
      this.$emit('ok', this.itemObj, this.num);
      this.$emit('cancel');
    },
    disabledDate(current) {
      if (this.selectPriceDate) {
        let selectV = moment(this.selectPriceDate, 'YYYY-MM-DD').valueOf();
        return current > moment().add(0, 'days') || current < moment(new Date(selectV - this.offsetDays), 'YYYY-MM-DD');
      } else {
        return current > moment().add(0, 'days');
      }
    },
    onChangeTime(date) {
      if (date.length) {
        this.itemObj.timeFrame = '';
        this.dateFrame = date;
        this.itemObj.timeName = date.join('~');
      } else {
        this.itemObj.timeFrame = 'MONTH';
        this.dateFrame = [];
        this.itemObj.timeName = this.$t('本月');
      }
    },
    tabFun(val, valName) {
      this.dateFrame = [];
      this.itemObj.timeFrame = val;
      this.itemObj.timeName = valName;
    },
    calendarPriceRangeChange(date) {
      this.selectPriceDate = date[0];
    }
  }
};